import { sanitizeRedirectPathToUrl } from '@reward-platform/utils'
import { getPlatformBasePath, getPlatformPathname } from '~/utils/platform'
import { AUTH_COOKIES, AUTH_SESSION_COOKIE_PREFIX, RequestCookies, serializeCookie } from '../utils'

const SILENT_LOGIN_RETURN_TO_FLAG_EXPIRY_TIME_IN_SECONDS = 60
const SILENT_LOGIN_FLAG_EXPIRY_TIME_IN_SECONDS = 300

export const serializeSilentLoginReturnToCookie = (returnTo: string, enabled: boolean): string =>
  serializeCookie(AUTH_COOKIES.SILENT_LOGIN_RETURN_TO, returnTo, {
    path: getPlatformBasePath() || '/',
    ...(enabled ? { maxAge: SILENT_LOGIN_RETURN_TO_FLAG_EXPIRY_TIME_IN_SECONDS } : { maxAge: 0 }),
  })

export const serializeSilentLoginCookie = (enabled: boolean): string =>
  serializeCookie(AUTH_COOKIES.HAS_RUN_SILENT_LOGIN_STATE, String(enabled), {
    maxAge: enabled ? SILENT_LOGIN_FLAG_EXPIRY_TIME_IN_SECONDS : 0,
  })

export const serializeAuth0ClearSessionCookies = (cookies: RequestCookies): string[] =>
  Object.keys(cookies)
    .filter((key) => key.startsWith(AUTH_SESSION_COOKIE_PREFIX))
    .map((key) => serializeCookie(key, '', { maxAge: 0 }))

export const getSanitizedReturnTo = (returnTo: string, baseUrl: string): string | undefined => {
  const safeBaseUrl = new URL(baseUrl)
  const sanitizedReturnToUrl = sanitizeRedirectPathToUrl(returnTo, safeBaseUrl)

  if (!sanitizedReturnToUrl) {
    return sanitizedReturnToUrl
  }

  return getPlatformPathname(`${sanitizedReturnToUrl.pathname}${sanitizedReturnToUrl.search ?? ''}`)
}
